module.exports = __webpack_public_path__ + "img/babbf99.png";